class AgeGate extends HTMLElement {
  constructor() {
    super();

    //// Testing script for styling age gate
    // document.addEventListener('DOMContentLoaded', function () {
    //   document.cookie = 'ofAge=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    // });

    this.monthInput = this.querySelector('#birth-month');
    this.dayInput = this.querySelector('#birth-day');
    this.yearInput = this.querySelector('#birth-year');
    this.button = this.querySelector('button');
    this.errorElement = this.querySelector('.age-gate__error');

    this.button.addEventListener('click', (e) => this.handleButtonClick(e));
    this.monthInput.addEventListener('change', (e) => this.handleMonthYearChange(this.monthInput, this.yearInput));
    this.yearInput.addEventListener('change', (e) => this.handleMonthYearChange(this.monthInput, this.yearInput));

    this.checkAgeCookie();
    this.handleDesignMode();
  }

  handleMonthYearChange(monthInput, yearInput) {
    const month = parseInt(monthInput.value);
    const dayInput = this.dayInput;
    const currentValue = parseInt(dayInput.value) || 0;
    
    // Clear existing options except the placeholder
    while (dayInput.options.length > 1) {
      dayInput.remove(1);
    }

    let daysInMonth = 31; // Default

    // Set days based on month
    switch (month) {
      case 4: // April
      case 6: // June
      case 9: // September 
      case 11: // November
        daysInMonth = 30;
        break;
      case 2: // February
        // Simple leap year calculation
        const year = parseInt(yearInput.value);
        daysInMonth = ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) ? 29 : 28;
        break;
    }

    // Add new options
    for (let i = 1; i <= daysInMonth; i++) {
      const option = document.createElement('option');
      option.value = i;
      option.text = i;
      dayInput.add(option);
    }

    // Restore previous selection if valid
    if (currentValue > 0 && currentValue <= daysInMonth) {
      dayInput.value = currentValue;
    }
  }

  getBirthDate() {
    const month = parseInt(this.monthInput.value);
    const day = parseInt(this.dayInput.value);
    const year = parseInt(this.yearInput.value);

    return new Date(year, month - 1, day); // month is 0-based
  }

  getAge(birthDate) {
    const today = new Date();
   
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    // Adjust age based on month
    if (monthDiff < 0) {
      age--; // Birthday hasn't occurred this year
    }

    // TODO: Uncomment this when we want to check the day
    else if (monthDiff === 0) {
      // If in same month, check the day
      if (today.getDate() < birthDate.getDate()) {
        age--;
      }
    }

    return age;
  }

  handleButtonClick(e) {
    const age = this.getAge(this.getBirthDate());

    if (age >= 21) {
      this.setCookie('ofAge', true, 365);
      let birthDate = this.getBirthDate().toLocaleDateString('en-US', {month: '2-digit', day: '2-digit', year: 'numeric'});
      this.setCookie('birthDate', birthDate, 365);
      this.checkAgeCookie();
    } else {
      this.errorElement.style.opacity = 1;
      this.errorElement.style.pointerEvents = 'auto';
    }
  }

  getCookie(cname) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  checkAgeCookie() {
    const ofAge = this.getCookie('ofAge');
    if (ofAge != '') {
      this.classList.add('hidden');
      document.body.style.overflow = 'auto';
    } else {
      this.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    }
  }

  handleDesignMode() {
    if (Shopify.designMode) {
      this.classList.add('hidden');
      document.body.style.overflow = 'auto';

      document.addEventListener('shopify:section:select', (event) => {
        if (event.target.id.includes('shopify-section-age-gate')) {
          this.classList.remove('hidden');
          document.body.style.overflow = 'hidden';
        }
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.target.id.includes('shopify-section-age-gate')) {
          this.classList.add('hidden');
          document.body.style.overflow = 'auto';
        }
      });
    }
  }
}

if (!customElements.get('age-gate')) {
  customElements.define('age-gate', AgeGate);
}
